import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { Block } from '../../Block'
import css from './BlockOveray.module.scss'

const BlockOverlay: React.FC = () => {
  const id = useSelector<AppState, string | null>(
    ({ artboard }) => artboard.dragAndDrop.dragged.id
  )

  const additionalIds = useSelector<AppState, string[]>(({ artboard }) =>
    artboard.dragAndDrop.dragged.ids.filter((aId) => aId !== id).reverse()
  )

  if (!id) {
    return null
  }

  return (
    <div className={css.container}>
      <div className={css.main}>
        <Block id={id} index={0} isOverlay />
      </div>
      {additionalIds.length > 0 && (
        <div className={css.list}>
          {additionalIds.map((aBlock, i) => (
            <div key={aBlock}>
              <Block id={aBlock} index={i} isOverlay />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default BlockOverlay
